import { useI18n } from 'vue-i18n'

function useFormattedCaseDetails() {
  const { t } = useI18n()

  function getFormattedCaseId(externalId: string): string {
    return `${t('Case No.')} ${externalId}`
  }

  return {
    getFormattedCaseId
  }
}

export default useFormattedCaseDetails
